import globalStore from '../index';
import { Geobackground } from '../../cordova/Geobackground';
import { NavigatorGeolocation } from '../../services/NavigatorGeolocation';
import { getDistanceFromLatLonInKm } from '@/services/utility';

let geoBackground = null;
let navGeolocation = new NavigatorGeolocation();

// initial state
const state = {
    mode: '',
    locationEnabled: false,
    position: null,
    history: [],
    permissionSet: false
};

// getters
const getters = {
    locationEnabled: state => state.locationEnabled,
    permissionSet: state => state.permissionSet,
    actual: state => state.position,  // state.locationEnabled ? state.position : null
    actualZona: state => {
        let config = globalStore.getters['company/config'];
        let user = globalStore.getters['auth/user'];
        console.log('actualZona', config, user, state.position);
        if (config && config.zonas && config.zonas.length && state.position) {
            for (let index = 0; index < config.zonas.length; index++) {
                let zona = config.zonas[index];
                let distance = getDistanceFromLatLonInKm(state.position.lat, state.position.lng, zona.lat, zona.lng) * 1000;
                if (distance < zona.radio) {
                    return zona;
                }
            }
        }
        if (user) {
            return config && config.zonas && config.zonas.length ? config.zonas.find(z => z.id === user.zona_id) : null;
        }
    }
};

// actions
const actions = {

    init (context, mode) {
        context.commit('SET_MODE', mode);
        if (process.env.CORDOVA) {
            geoBackground = new Geobackground();
            geoBackground.checkLocationMode().then((enabled) => {
                context.dispatch('toogleSettings', enabled);
                navGeolocation.watch({
                    enableHighAccuracy: true,
                    timeout: 10000

                });
            });
            // geoBackground.watchLocationMode(true);
        } else {
            // Siempre enabled en el browser
            context.commit('LOCATION_ENABLED_SET', true);
            context.dispatch('toogleSettings', true);
        }
    },

    onLogout (context) {
        geoBackground.watchLocationMode(false);
        navGeolocation.clear();
        context.dispatch('stop');
    },

    toogleSettings (context, enabled) {
        context.commit('LOCATION_ENABLED_SET', enabled);
        if (enabled) {
            context.dispatch('start');
        } else {
            context.dispatch('stop');
        }
    },

    /**
     * Arranca el servicio de geolocalizacion según el modo
     * @param {store} context
     * @param {string} mode 'foreground' | 'background'
     */
    start (context) {
        // context.commit('SET_MODE', mode);
        let mode = context.state.mode;
        switch (mode) {
            case 'foreground':
                console.log('foreground location start navGeo');
                let options;
                if (!process.env.CORDOVA) {
                    options = {
                        maximumAge: Infinity,
                        enableHighAccuracy: false
                    };
                }
                navGeolocation.watch(options);
                break;
            case 'background':
                if (process.env.CORDOVA) {
                    // console.log('background location start');
                    let authHeaders = globalStore.getters['auth/authHeader'];
                    geoBackground.configure(process.env.API_URL + '/api/conductor/coordenadas', authHeaders);
                    geoBackground.startTracking().then(() => {
                        console.log('background location started');
                    });
                } else {
                    console.log('brackground location start navGeo');
                    let options = {
                        maximumAge: Infinity,
                        enableHighAccuracy: false
                    };
                    navGeolocation.watch(options);
                    setTimeout(() => {
                        console.log('xxxx');
                        globalStore.commit('geolocation/LOCATION_ENABLED_SET', true);
                        let pos = {
                            lat: -32.957778,
                            lng: -60.631489
                        };
                        globalStore.commit('geolocation/SET_POSITION', pos);
                    }, 100);
                }
                break;
        }
    },

    /**
     * Detiene los procesos de geolocation
     * @param {store} context
     */
    stop (context) {
        switch (context.state.mode) {
            case 'foreground':
                navGeolocation.clear();
                break;
            case 'background':
                if (process.env.CORDOVA) {
                    geoBackground.stopTracking();
                } else {
                    navGeolocation.clear();
                }
                break;
        }
    },

    callToLocationSettings () {
        if (process.env.CORDOVA) {
            geoBackground.showLocationSettings();
        } else {
            //
        }
    },

    updatePosition (store, position) {
        store.commit('SET_POSITION', position);
        const user = globalStore.getters['auth/user'];
        if (user && user.chofer) {
            globalStore.dispatch('driver/updatePosition', position);
        }
    },

    adquireNewPosition () {
        navGeolocation.get();
    },

    getCurrentZoneForPoint (store, obj) {
        console.log('getCurrentZoneForPoint', obj);
        let config = globalStore.getters['company/config'];
        if (config && config.zonas && config.zonas.length) {
            for (let index = 0; index < config.zonas.length; index++) {
                let zona = config.zonas[index];
                let distance = getDistanceFromLatLonInKm(obj.lat, obj.lng, zona.lat, zona.lng) * 1000;
                if (distance < zona.radio) {
                    console.log('getCurrentZoneForPoint', zona);
                    return zona;
                }
            }
        }
        return null;
    }

};

// mutations
const mutations = {
    LOCATION_ENABLED_SET (state, data) {
        state.locationEnabled = data;
    },
    PERMISION_SET (state, data) {
        state.permissionSet = data;
    },

    SET_POSITION (state, position) {
        state.position = position;
        // state.history.push({
        //     position,
        //     datetime: new Date() // [TODO] Implementar moment para fechas
        // });
    },

    SET_MODE (state, mode) {
        state.mode = mode;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/geolocation.js